import { AppState, Auth0Provider } from '@auth0/auth0-react'
import { useNavigate } from 'react-router-dom'
import { App } from './App'
import { getAuthConfig } from './config'

export const AuthenticatedApp = () => {
  const navigate = useNavigate()

  const authConfig = getAuthConfig()
  authConfig.onRedirectCallback = (appState?: AppState) => {
    navigate(appState?.returnTo || '/', { replace: true })
  }

  return (
    <Auth0Provider {...authConfig}>
      <App />
    </Auth0Provider>
  )
}
